<template>
  <div class="preloader"></div>
</template>

<style scoped>
.preloader {
  display: block;
  width: 100px;
  height: 100px;
  border: 4px solid theme("colors.gray.300");
  border-bottom-color: theme("colors.blue.500");

  border-radius: 50%;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  animation: spin 0.75s infinite linear;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
